import { gql } from "@apollo/client";

export const BooleanExtractor = gql`
  query searchconfig($jobDescription: String!, $token: String!) {
    searchConfigGenerator(token: $token, text: $jobDescription) {
      jobTitles
      skills
      companies
      companiesExclude
      locationsExclude
      locations
      experienceMin
      experienceMax
      suggestedSkills
      suggestedJobTitles
      keywords
      description
    }
  }
`;

export const TitleSearch = gql`
  query StatsToTile($title: [String], $skills: [Graphene_Skill], $token: String!) {
    statsToTitle(toTitles: $title, toSkills: $skills, token: $token) {
      titles {
        name
        count
      }
      skills {
        name
        count
      }
    }
  }
`;

/**
 * query keyword_suggestor{
    keywordSuggestor(
          jobTitles: ["quantative analyst", "CTO"]
          token: "super_secret_token_that_bypasses_authorization_299792458"
  ){
    keywords
  }
  
}
 */


export const KeywordSuggester = gql`
query suggestor($jobTitles: [String]!, $token: String!, $keywords: [String]!) {
  jobTitlesAndKeywordsSuggestor(jobTitles: $jobTitles, token: $token, keywords: $keywords) {
    jobTitles
    keywords
  }
}
`;

// export const KeywordSuggester = gql`
//   query suggestor($token: String!, $jobTitles: [String!]!, $keywords: [String!]) {
//     jobTitlesAndKeywordsSuggestor(token: $token, jobTitles: $jobTitles, keywords: $keywords) {
//       jobTitles
//       keywords
//     }
//   }
// `;


// export const KeywordSuggester = gql`
//   query keyword_suggestor($jobTitles: [String]!, $token: String!) {
//     keywordSuggestor(jobTitles: $jobTitles, token: $token) {
//       keywords
//     }
//   }
// `;

export const TitleSuggesterGQL = gql`
  query StatsToTile($title: [String], $skills: [Graphene_Skill], $token: String!) {
    statsToTitle(toTitles: $title, toSkills: $skills, token: $token) {
      titles {
        name
        count
      }
      skills {
        name
        count
      }
    }
  }
`;

export const COMPANY_TYPE = gql`
  query company_grp($token: String!) {
    companyGroups(token: $token) {
      result
    }
  }
`;


export const CHAT_SESSIONS_QUERY = gql`
query chatSessions($token: String!, $userEmail: String!) {
  chatSessions(token: $token, userEmail: $userEmail) {
    session {
      chatTitle
      sessionId
      createdAt
      mode
    } 
  }
}
`;


export const CHATBOT_HISTORY = gql`
  query chatmessages($token: String!, $sessionId: String!) {
    chatMessages(token: $token, sessionId: $sessionId) {
      messages {
        sender
        message
        timestamp
        sessionId
        config{
        description
        salaryMin
        experienceMin
        experienceMax
        jobTitles
        salaryMin
        locations
        keywords
        locations
        companies
        suggestedCompanies
        suggestedKeywords
        suggestedJobTitles
        suggestedLocations
        suggestedIndustries
        fullName
      }
      }
    }
  }
`;

export const SEARCH_ASSISTANT_CHATBOT = gql`
  subscription chatbot(
    $token: String!
    $question: String!
    $userEmail: String!
    $sessionId: String!
    $hiringCompany: String!
  ) {
    aiAssistant(token: $token, question: $question, userEmail: $userEmail, sessionId: $sessionId, hiringCompany: $hiringCompany) {
      sessionId
      answer
      chatTitle
      searchConfig {
        description
        jobTitles
        suggestedJobTitles
        keywords
        companies
        suggestedCompanies
        suggestedIndustries
        industries
        locations
        locationsExclude
        experienceMin
        experienceMax
      }
      jobDescription
    }
  }
`;

export const RESEARCH_ASSISTANT_CHATBOT = gql`
    subscription chatbot(
    $token: String!
    $question: String!
    $userEmail: String!
    $sessionId: String!
  ){
  aiResearchAssistant(
   token: $token, question: $question, userEmail: $userEmail, sessionId: $sessionId
  )
  {
    sessionId
    answer
    chatTitle
  }
}`;

export const AI_ASSISTANT_CHATBOT = gql`
  subscription chatbot23(
    $token: String!
    $question: String!
    $userEmail: String!
    $sessionId: String!
    $jobDetails: Graphene_JobDetails
    $nameSearch: Boolean!
  ) {
    aiAssistant(
    token: $token, 
    question: $question, 
    userEmail: $userEmail, 
    sessionId: $sessionId,
    jobDetails: $jobDetails,
    nameSearch: $nameSearch
    ) {
    sessionId
    answer
    chatTitle
    jobDescription
    searchConfig{
        description
        salaryMin
        experienceMin
        experienceMax
        jobTitles
        jobTitlesExclude
        salaryMin
        locations
        locationsExclude
        keywords
        locations
        companies
        companiesExclude
        industries
        fullName
      }
  }
  }
`;

export const OUTREACH_EMAIL_SUBSCRIPTION = gql`
    subscription OutreachEmail(
      $token: String!
      $profileId: Int
      $config: Graphene_SearchConfig
      $configId: Int
      $formatResult: Boolean
      $template: Graphene_EmailTemplate
      $externalCompany: String
    ) {
      emailOutreach(
        token: $token
        profileId: $profileId
        config: $config
        configId: $configId
        formatResult: $formatResult
        template: $template
        externalCompany: $externalCompany
      ) {
        text
        timeTaken
        error
        finished
        subject
      }
    }
  `;

const SEARCH_BY_NAME = gql`
  subscription chatbot23 {
  aiAssistant(
    token:"super_secret_token_that_bypasses_authorization_299792458"
    question: "he lives in either spain or NY "
    userEmail: "uma@sinecure.ai"
    sessionId: "233add11-12fb-4af3-9550-949836fbeff4"
    jobDetails: {
      jobTitle: "CEO"
      keywords: ["Management"]
      locations: ["New York"]
    }
    nameSearch: true
  )
  {
    sessionId
    answer
    chatTitle
    jobDescription
    searchConfig{
        salaryMin
        experienceMin
        experienceMax
        jobTitles
        salaryMin
        locations
        keywords
        locations
        companies
        suggestedCompanies
        suggestedKeywords
        suggestedJobTitles
        suggestedLocations
        suggestedIndustries
      	fullName
      }
  }
}`;

export const COMPANY_INFO_QUERY = gql`
  query GetCompanyInfo(
    $token: String!
    $companyName: String!
    $documentType: String!
  ) {
    companyInfo(
      token: $token
      companyName: $companyName
      documentType: $documentType
    ) {
      name
      logoUrl
      location
      website
      tagline
      description
      linkedinUrl
      text
      finished
    }
  }
`;

export const COUNT_SEARCH = gql`
  query Count($configId: Int, $token: String!) {
    countSearch(configId: $configId, token: $token) {
      total
      details {
        name
        count
      }
    }
  }
`;

// export const AGENT_CHATBOT = gql`
//   subscription chatbot1(
//     $token: String!
//     $pageName: String!
//     $message: String!
//     $userEmail: String!
//     $sessionId: String!
//     $searchType: String!
//     // $searchId: Int
//     // $jobDetails: Graphene_JobDetails
//     // $nameSearch: Boolean
//   ) {
//     agentChat(
//       token: $token
//       pageName: $pageName
//       message: $message
//       userEmail: $userEmail
//       sessionId: $sessionId
//       searchType: $searchType
//       searchId: $searchId
//       jobDetails: $jobDetails
//       nameSearch: $nameSearch
//     ) {
//       sessionId
//       answer
//       chatTitle
//       jobDescription
//       finished
//       searchConfig {
//         description
//         salaryMin
//         experienceMin
//         experienceMax
//         jobTitles
//         jobTitlesExclude
//         locations
//         locationsExclude
//         keywords
//         companies
//         companiesExclude
//         industries
//         suggestedCompanies
//         suggestedKeywords
//         suggestedJobTitles
//         suggestedLocations
//         suggestedIndustries
//         profileIds
//         fullName
//       }
//     }
//   }
// `;

export const AGENT_CHATBOT = gql`
  subscription chatbot1(
    $token: String!
    $pageName: String!
    $message: String!
    $userEmail: String!
    $sessionId: String!
    $searchType: String!
    $searchId: Int
    $jobDetails: Graphene_JobDetails
    $searchConfig: Graphene_PartialConfigInput
  ) {
    agentChat(
      token: $token
      pageName: $pageName
      message: $message
      userEmail: $userEmail
      sessionId: $sessionId
      searchType: $searchType
      searchId: $searchId
      jobDetails: $jobDetails
      searchConfig: $searchConfig
    ) {
      sessionId
      answer
      chatTitle
      jobDescription
      finished
      searchConfig {
        description
        salaryMin
        experienceMin
        experienceMax
        jobTitles
        jobTitlesExclude
        locations
        locationsExclude
        keywords
        companies
        companiesExclude
        industries
        suggestedCompanies
        suggestedKeywords
        suggestedJobTitles
        suggestedLocations
        suggestedIndustries
        profileIds
        fullName
      }
    }
  }
`;

// export const AGENT_CHATBOT = gql`
//   query agentChatbotQuery(
//     $token: String!
//     $pageName: String!
//     $message: String!
//     $userEmail: String!
//     $sessionId: String!
//     $searchType: String!
//     $searchId: Int
//     $jobDetails: Graphene_JobDetails
//     $nameSearch: Boolean
//   ) {
//     agentChat(
//       token: $token
//       pageName: $pageName
//       message: $message
//       userEmail: $userEmail
//       sessionId: $sessionId
//       searchType: $searchType
//       searchId: $searchId
//       jobDetails: $jobDetails
//       nameSearch: $nameSearch
//     ) {
//       sessionId
//       answer
//       chatTitle
//       jobDescription
//       finished
//       searchConfig {
//         description
//         salaryMin
//         experienceMin
//         experienceMax
//         jobTitles
//         jobTitlesExclude
//         locations
//         locationsExclude
//         keywords
//         companies
//         companiesExclude
//         industries
//         suggestedCompanies
//         suggestedKeywords
//         suggestedJobTitles
//         suggestedLocations
//         suggestedIndustries
//         profileIds
//         fullName
//       }
//     }
//   }
// `;